import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckListItemList } from './CheckListItemList';
import { useChecklistComponent } from './useChecklistComponent';
import { AccessList, useHasAccess, useUser } from '~/Hooks';
import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_LARGE, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { BORDER_COLOR, WHITE, DARK_GREY } from '~/Constants/Colors.constants';

const useStyles = makeStyles((theme) => ({
  checklistContainer: {},
  checklistItemListContainer: {
    margin: 15,
    padding: 15,
    backgroundColor: WHITE,
    border: `thin solid ${BORDER_COLOR}`,
    [theme.breakpoints.up('md')]: {
      margin: '0 0 0 15px',
      position: 'sticky',
      top: 0,
    },
  },
  checklistHeader: {
    fontSize: FONT_SIZE_LARGE,
    fontWeight: 'bold',
    letterSpacing: 0.5,
    lineHeight: '24px',
  },
  checklistDescription: {
    fontSize: FONT_SIZE_SMALLISH,
    fontWeight: 300,
    letterSpacing: 0.5,
    lineHeight: '20px',
    margin: '15px 0',
    whiteSpace: 'pre-line',
    color: DARK_GREY,
  },
}));

export const Checklist = () => {
  const {
    checklistItems,
    isCheckListLoading,
    checklistError,
    activeIndex,
    checklistFooter,
    isChecklistDone,
    extraComponent,
  } = useChecklistComponent();
  const { hasAccess } = useHasAccess();
  const { t } = useTranslation();
  const { currentUser } = useUser();
  const { classes } = useStyles();

  // if there is an error with the checklist, don't show it (providers dont need to know about that).
  if (isChecklistDone || isCheckListLoading || checklistError || !hasAccess(AccessList.CHECKLIST)) {
    return null;
  }

  return (
    <div className={classes.checklistContainer}>
      <div className={classes.checklistItemListContainer}>
        <div className={classes.checklistHeader}>
          {t('dashboard.checklist.title', {
            userName: `${currentUser?.first_name
              .charAt(0)
              .toUpperCase()}${currentUser?.first_name.slice(1)}`,
          })}
        </div>
        <div
          className={classes.checklistDescription}
          dangerouslySetInnerHTML={{
            __html: t('dashboard.checklist.description', { newLine: '\n' }),
          }}
        />
        <CheckListItemList
          checkListItems={checklistItems}
          activeIndex={activeIndex}
          checklistFooter={checklistFooter}
        />
      </div>
      {extraComponent}
    </div>
  );
};
